import { render, staticRenderFns } from "./CommEdit.vue?vue&type=template&id=10536289&"
import script from "./CommEdit.vue?vue&type=script&lang=js&"
export * from "./CommEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports